<template>
  <div v-if="badgeDisplay" class="d-inline-block">
    <b-badge v-if="badgeDisplayLatest" :variant="badgeColor(latest)">
      {{ badgeTextLatest }}
    </b-badge>
    <b-badge v-if="badgeDisplayAverage" :variant="badgeColor(average)">
      {{ badgeTextAverage }}
    </b-badge>
  </div>
</template>

<script>
import * as Store from '@/common/js/store.js'

export default {
  name: 'Badges',
  props: ['drill'],
  data () {
    return {
      currentUser: null,
      latest: 0,
      trials: 0,
      average: 0
    }
  },
  created: function () {
    this.currentUser = Store.userRecord.current()
    this.latest = Store.scoreRecord.latest(this.currentUser.id, this.drill)
    this.trials = Store.scoreRecord.trials(this.currentUser.id, this.drill)
    this.average = Store.scoreRecord.average(this.currentUser.id, this.drill)
  },
  computed: {
    badgeDisplay: function () {
      return this.trials > 0
    },
    badgeDisplayLatest: function () {
      // check Settings.vue for options
      return (
        this.currentUser.badge === 'latest' ||
        this.currentUser.badge === 'all'
      )
    },
    badgeDisplayAverage: function () {
      // check Settings.vue for options
      return (
        this.currentUser.badge === 'average' ||
        this.currentUser.badge === 'all'
      )
    },
    badgeTextLatest: function () {
      return this.latest + '%'
    },
    badgeTextAverage: function () {
      return this.average + '% (' + this.trials + ')'
    }
  },
  methods: {
    badgeColor (score) {
      if (score < 50) return 'danger'
      else if (score < 90) return 'warning'
      else return 'info'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/Badges.vue